import React from 'react';
import i18n from '@i18n';

import { cashinStatus } from '@/mytickets/constants/cashinStatus';
import { DialogBody, DialogTitle } from '@/ui/dialogs/Dialog';

function CashinStatus({ cashinTransaction }) {
    return (
        <>
            <DialogTitle>
                <h2>{i18n('commons.term.odkupH1')}</h2>
            </DialogTitle>
            <DialogBody>
                <div className="ajax-preloader" />
                <div className="cashin-waiting">
                    {cashinStatus.AuthorizationRequired === cashinTransaction.get('status')
                        ? i18n('ticketus.cashin.status.AuthorizationRequired')
                        : i18n('ticketus.cashin.wait')}
                </div>
            </DialogBody>
        </>
    );
}

export default CashinStatus;
